import { getSearchParametersFromObject } from '../../abstracts/url.js';
import filterList from '../filters/filterList';
import tagmanager from '../../abstracts/tagmanager.js';

const tourFilterList = (filters, sort, country, federalState, page) => ({
  ...filterList(filters, country, federalState, page),

  sort: sort,

  afterInit() {
    this.watchAndExecute('sort', () => this.gotoPage(1));
    this.watchAndExecute('filters.search', () => this.gotoPage(1));

    this.watchAndExecute('filters.countryOrState', (value) =>
      this.filterNavigationSelected('locationEntryPoint', value),
    );
    this.watchAndExecute('filters.region', (value) =>
      this.filterNavigationSelected('region', value),
    );
    this.watchAndExecute('filters.typeOrCategory', (value) =>
      this.filterNavigationSelected('typeOrCategory', value),
    );
  },

  getSearchParams() {
    return getSearchParametersFromObject({
      filters: {
        search: this.filters.search,
        difficulty: this.filters.difficulty,
        distance: this.filters.distance,
        duration: this.filters.duration,
        elevation: this.filters.elevation,
      },
      sort: this.sort,
      page: this.page,
    });
  },

  trackEvent(event, selection) {
    tagmanager.event(event, {
      Category: 'tour',
      Selection: selection ?? false,
      Country: this.country,
      Federalstate: this.federalState,
    });
  },
});

export default tourFilterList;
